import { SKIP_LINK_SEGMENTS } from "./constants";
import type { DynamicIds } from "./types";

export interface IdExtractor {
  key: keyof DynamicIds;
  condition: (
    segments: string[],
    params: Record<string, string | undefined>
  ) => boolean;
  getValue: (
    segments: string[],
    params: Record<string, string | undefined>
  ) => string | undefined;
}

export const ID_EXTRACTORS: IdExtractor[] = [
  {
    key: "site",
    condition: (segments, params) =>
      Boolean(params.id && (segments[0] === "site" || segments[0] === "sites")),
    getValue: (_segments, params) => params.id,
  },
  {
    key: "worker",
    condition: (segments) => segments[0] === "workers",
    getValue: (_segments, params) => params.id,
  },
  {
    key: "entrance",
    condition: (segments) =>
      segments[0] === "sites" && segments[2] === "entrances",
    getValue: (_segments, params) => params.entranceId,
  },
  {
    key: "template",
    condition: (segments) =>
      segments[0] === "forms" && segments[1] === "templates",
    getValue: (_segments, params) => params.templateId,
  },
  {
    key: "form",
    condition: (segments) =>
      segments[0] === "forms" &&
      (segments[1] === "permits" ||
        segments[1] === "training" ||
        segments[1] === "records") &&
      Boolean(segments[2]?.length),
    getValue: (_segments, params) => params.formId,
  },
  {
    key: "signIn",
    condition: (segments) =>
      segments[0] === "signins" && Boolean(segments[1]?.length),
    getValue: (_segments, params) => params.signInId,
  },
];

export function extractIds(
  segments: string[],
  params: Record<string, string | undefined>
): Record<keyof DynamicIds, string | undefined> {
  const extractedIds: Record<string, string | undefined> = {};

  ID_EXTRACTORS.forEach(({ key, condition, getValue }) => {
    if (condition(segments, params)) {
      extractedIds[key] = getValue(segments, params);
    }
  });

  return extractedIds as Record<keyof DynamicIds, string | undefined>;
}

export function createDynamicIds(
  extractedIds: Record<keyof DynamicIds, string | undefined>
): DynamicIds {
  const dynamicIds: DynamicIds = {
    site: undefined,
    worker: undefined,
    entrance: undefined,
    template: undefined,
    form: undefined,
    signIn: undefined,
  };

  Object.entries(extractedIds).forEach(([key, value]) => {
    if (value && !SKIP_LINK_SEGMENTS.has(value)) {
      dynamicIds[key as keyof DynamicIds] = value;
    }
  });

  return dynamicIds;
}
